module.exports = __webpack_public_path__ + "img/data-syr.e70e35fe.png";